/* eslint-disable */
import $ from 'jquery';
import _ from 'lodash';
import 'magnific-popup';

$.extend(true, $.magnificPopup.defaults, {
    type: 'inline',
    removalDelay: 300,
    mainClass: 'mfp-zoom-in',
});

if ($('.js-popup').length) {
  $('.js-popup').magnificPopup({
      callbacks: {
          open: function() {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                  event: 'openModal',
                  name: _.chain(this.currItem.src)
                         .split('-')
                         .drop()
                         .join(' ')
                         .startCase()
                         .value(),
              });
          }
      }
  });
}

if ($('.js-popup-modal').length) {
  $('.js-popup-modal').magnificPopup({
      modal: true,
  });
}

